import React from "react";
import { Icon, Typography } from "@mui/material";

import RpMuiToolTip from "@/components/muiCustom/popover/RpMuiToolTip";
import RpSvgIcon from "@/components/icons/RpSvgIcon";

const headerTooltipContent = {
  Location: "These locations are currently enrolled in this campaign.",
  Status:
    "This shows the status of advertising for each location. Locations with advertising past their end date will not appear on this list.",
  Toggle: "Set Live or Pause all locations.",
};

function PauseHeaderTooltip({ label = "" }) {
  return (
    <span className="d-inline-block">
      <RpMuiToolTip
        content={
          <Typography component="p" variant="caption" className="fs-10">
            {headerTooltipContent[label]}
          </Typography>
        }
      >
        <span className="d-inline-block">
          <Icon
            component={RpSvgIcon}
            name="green_info"
            fontSize="small"
            color="primary"
            style={{ width: 15, height: 15 }}
            className="ml-1 cursor-p d-none d-lg-block"
          />
        </span>
      </RpMuiToolTip>
    </span>
  );
}

export default PauseHeaderTooltip;
